import { useMemo } from 'react';
import { Col, Form, Input, Row, Select } from 'antd';
import { BDMs_BY_REGION, REGIONS } from './bdmData';
import type { BDMFieldProps } from './bdmData';
import { useTranslation } from 'react-i18next';

export type { BDMValue } from './bdmData';

/* POC: only the bdm value is sent to the backend; region, contact number, and all data are mocked */
export const BDMField: React.FC<BDMFieldProps> = ({ value = {}, onChange, readonly = false }) => {
  const { t } = useTranslation();
  const { region, bdm } = value;

  const bdmList = useMemo(() => (region ? (BDMs_BY_REGION[region] ?? []) : []), [region]);
  const selected = useMemo(() => (bdm ? (bdmList.find(b => b.value === bdm) ?? null) : null), [bdm, bdmList]);
//TODO add required to Form.Item when be ready
  return (
    <Row gutter={16}>
      <Col span={8}>
        <Form.Item label={t('lender.firms.labels.region')}>
          <Select
            placeholder={readonly ? undefined : t('lender.firms.labels.regionPlaceholder')}
            options={REGIONS}
            allowClear
            showSearch
            optionFilterProp="label"
            value={region ?? undefined}
            onChange={(v: string) => onChange?.({ ...value, region: v, bdm: null })}
            disabled={readonly}
          />
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item label={t('lender.firms.labels.businessDevelopmentManager')}>
          <Select
            placeholder={
              readonly
                ? undefined
                : region
                  ? t('lender.firms.labels.businessDevelopmentManagerPlaceholder')
                  : t('lender.firms.labels.pickARegionPlaceholder')
            }
            options={bdmList}
            allowClear
            showSearch
            optionFilterProp="label"
            value={bdm ?? undefined}
            onChange={(v: string) => onChange?.({ ...value, bdm: v })}
            disabled={readonly || !region}
          />
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item label={t('lender.firms.labels.bdmContactNumber')}>
          <Input value={selected?.phone ?? ''} readOnly disabled />
        </Form.Item>
      </Col>
    </Row>
  );
};